import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(8),
  },
  loadingText: {
    color: theme.palette.text.primary,
    fontSize: "1.25rem"
  }
}));

const waitingText = "Ein Augenblick bitte…";

const Loading = ({ children, isLoading = false, isLongWait = false }) => {
  const classes = useStyles();

  return isLoading ? (
    <div className={classes.root}>
      {isLongWait && <p className={classes.loadingText}>{waitingText}</p>}
      <CircularProgress />
    </div>
  ) : (
    children
  );
};

Loading.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
};

export default Loading;
